export default __webpack_public_path__ + "static/80-e681dac7579a624c19c55fcd662a68cd.png";